import { render, staticRenderFns } from "./lockers.vue?vue&type=template&id=1a9650e8"
import script from "./lockers.vue?vue&type=script&lang=js"
export * from "./lockers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports